module.exports = __webpack_public_path__ + "static/media/check.9af9f690.svg";